import createReactComponent from "../createReactComponent";
import defaultAttributes from "../defaultAttributes";
var MoreHorizontal = createReactComponent("MoreHorizontal", ["svg", defaultAttributes, [["circle", {
  cx: "12",
  cy: "12",
  r: "1",
  key: "1cly3i"
}], ["circle", {
  cx: "19",
  cy: "12",
  r: "1",
  key: "14bauv"
}], ["circle", {
  cx: "5",
  cy: "12",
  r: "1",
  key: "11uqdf"
}]]]);
export default MoreHorizontal;